module.exports = __webpack_public_path__ + "img/class_revenue_icon.9b05e6e2.svg";